import React from 'react';

export default function InnovationSection() {
  return (
    <section id="innovation" style={{ padding: 0 }}>
      <div className="inno-l rl">
        <div className="kicker k-gold">Innovation Lab</div>
        <h2 className="title lt">
          The science
          <br />
          behind <em>the color</em>
        </h2>
        <div className="inno-items">
          <div className="inno-row">
            <div className="inno-n">01</div>
            <div>
              <h4>AI-Powered Color Formulation</h4>
              <p>
                Spectrophotometric matching algorithms trained on 10,000+ real-world outcomes cut development from weeks
                to 72 hours, with full CIELab validation at every stage.
              </p>
            </div>
          </div>
          <div className="inno-row">
            <div className="inno-n">02</div>
            <div>
              <h4>Nano-Scale Dispersion Technology</h4>
              <p>
                Twin-screw nano-compounding achieves pigment uniformity that eliminates gels, specks, and flow marks at
                source — not downstream on your production line.
              </p>
            </div>
          </div>
          <div className="inno-row">
            <div className="inno-n">03</div>
            <div>
              <h4>Real-Time In-Line Quality Control</h4>
              <p>
                NIR and spectral sensors monitor melt quality, pigment concentration, and IV retention continuously. Every
                batch ships with a QR-linked digital Certificate of Analysis.
              </p>
            </div>
          </div>
          <div className="inno-row">
            <div className="inno-n">04</div>
            <div>
              <h4>Recyclability-First Product Design</h4>
              <p>
                Every new formulation is tested through simulated mechanical recycling loops. Carriers and pigments are
                selected for post-consumer performance from day one of development.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="inno-r">
        <svg viewBox="0 0 420 480" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: '100%', maxWidth: 420 }}>
          <defs>
            <radialGradient id="M1" cx="50%" cy="50%" r="50%">
              <stop offset="0%" stopColor="#D4AF37" stopOpacity="0.9" />
              <stop offset="100%" stopColor="#D4AF37" stopOpacity="0.1" />
            </radialGradient>
            <radialGradient id="M2" cx="50%" cy="50%" r="50%">
              <stop offset="0%" stopColor="#2E8B57" stopOpacity="0.9" />
              <stop offset="100%" stopColor="#2E8B57" stopOpacity="0.1" />
            </radialGradient>
            <radialGradient id="M3" cx="50%" cy="50%" r="50%">
              <stop offset="0%" stopColor="#007BFF" stopOpacity="0.9" />
              <stop offset="100%" stopColor="#007BFF" stopOpacity="0.1" />
            </radialGradient>
            <filter id="MF">
              <feGaussianBlur stdDeviation="5" result="b" />
              <feMerge>
                <feMergeNode in="b" />
                <feMergeNode in="SourceGraphic" />
              </feMerge>
            </filter>
          </defs>
          <g opacity="0.1" stroke="rgba(212,175,55,0.8)" strokeWidth="1">
            <line x1="60" y1="80" x2="140" y2="120" />
            <line x1="140" y1="120" x2="220" y2="80" />
            <line x1="60" y1="200" x2="140" y2="230" />
            <line x1="140" y1="230" x2="220" y2="200" />
            <line x1="60" y1="80" x2="60" y2="200" />
            <line x1="220" y1="80" x2="220" y2="200" />
          </g>
          <line x1="210" y1="240" x2="130" y2="172" stroke="#D4AF37" strokeWidth="2.2" opacity="0.7">
            <animate attributeName="opacity" values="0.5;0.9;0.5" dur="3s" repeatCount="indefinite" />
          </line>
          <line x1="210" y1="240" x2="300" y2="182" stroke="#007BFF" strokeWidth="2.2" opacity="0.7">
            <animate attributeName="opacity" values="0.9;0.5;0.9" dur="4s" repeatCount="indefinite" />
          </line>
          <line x1="210" y1="240" x2="148" y2="322" stroke="#2E8B57" strokeWidth="2" opacity="0.7">
            <animate attributeName="opacity" values="0.6;0.95;0.6" dur="3.5s" repeatCount="indefinite" />
          </line>
          <line x1="210" y1="240" x2="310" y2="314" stroke="#D4AF37" strokeWidth="2" opacity="0.6">
            <animate attributeName="opacity" values="0.4;0.8;0.4" dur="5s" repeatCount="indefinite" />
          </line>
          <line x1="130" y1="172" x2="300" y2="182" stroke="rgba(212,175,55,0.22)" strokeWidth="1.5" />
          <line x1="300" y1="182" x2="310" y2="314" stroke="rgba(0,123,255,0.22)" strokeWidth="1.5" />
          <line x1="148" y1="322" x2="310" y2="314" stroke="rgba(46,139,87,0.22)" strokeWidth="1.5" />
          <line x1="210" y1="240" x2="210" y2="130" stroke="rgba(255,255,255,0.09)" strokeWidth="1.5" />
          <line x1="210" y1="240" x2="210" y2="376" stroke="rgba(255,255,255,0.09)" strokeWidth="1.5" />
          <circle cx="210" cy="240" r="28" fill="url(#M1)" filter="url(#MF)">
            <animate attributeName="r" values="24;34;24" dur="3s" repeatCount="indefinite" />
          </circle>
          <circle cx="210" cy="240" r="13" fill="#D4AF37" />
          <circle cx="210" cy="240" r="6" fill="#F2D98C" />
          <circle cx="130" cy="172" r="20" fill="url(#M2)" filter="url(#MF)">
            <animate attributeName="r" values="16;23;16" dur="4s" repeatCount="indefinite" />
          </circle>
          <circle cx="130" cy="172" r="10" fill="#2E8B57" />
          <circle cx="300" cy="182" r="18" fill="url(#M3)" filter="url(#MF)">
            <animate attributeName="r" values="14;21;14" dur="3.5s" repeatCount="indefinite" />
          </circle>
          <circle cx="300" cy="182" r="9" fill="#007BFF" />
          <circle cx="148" cy="322" r="16" fill="url(#M1)" filter="url(#MF)">
            <animate attributeName="r" values="12;19;12" dur="5s" repeatCount="indefinite" />
          </circle>
          <circle cx="148" cy="322" r="8" fill="#D4AF37" />
          <circle cx="310" cy="314" r="16" fill="url(#M2)" filter="url(#MF)">
            <animate attributeName="r" values="12;19;12" dur="2.8s" repeatCount="indefinite" />
          </circle>
          <circle cx="310" cy="314" r="8" fill="#2E8B57" />
          <circle cx="210" cy="130" r="12" fill="url(#M3)" filter="url(#MF)">
            <animate attributeName="r" values="9;14;9" dur="4.2s" repeatCount="indefinite" />
          </circle>
          <circle cx="210" cy="130" r="6" fill="#007BFF" />
          <circle cx="210" cy="376" r="12" fill="url(#M1)" filter="url(#MF)">
            <animate attributeName="r" values="9;14;9" dur="3.8s" repeatCount="indefinite" />
          </circle>
          <circle cx="210" cy="376" r="6" fill="#D4AF37" />
          <circle r="5" fill="#F2D98C" opacity="0.9">
            <animateMotion dur="10s" repeatCount="indefinite">
              <mpath href="#MolOrb" />
            </animateMotion>
          </circle>
          <ellipse id="MolOrb" cx="210" cy="240" rx="118" ry="76" fill="none" transform="rotate(-18 210 240)" />
          <rect x="2" y="158" width="100" height="22" rx="2" fill="rgba(8,14,24,0.92)" stroke="rgba(46,139,87,0.5)" strokeWidth="1" />
          <text x="52" y="174" textAnchor="middle" fill="#5FD48B" fontSize="10" fontFamily="monospace">
            Nano Dispersion
          </text>
          <rect x="296" y="164" width="110" height="22" rx="2" fill="rgba(8,14,24,0.92)" stroke="rgba(0,123,255,0.5)" strokeWidth="1" />
          <text x="351" y="180" textAnchor="middle" fill="#66B2FF" fontSize="10" fontFamily="monospace">
            AI Color Match
          </text>
          <rect x="40" y="310" width="88" height="22" rx="2" fill="rgba(8,14,24,0.92)" stroke="rgba(212,175,55,0.4)" strokeWidth="1" />
          <text x="84" y="326" textAnchor="middle" fill="#F2D98C" fontSize="10" fontFamily="monospace">
            UV Analytics
          </text>
          <rect x="316" y="300" width="90" height="22" rx="2" fill="rgba(8,14,24,0.92)" stroke="rgba(46,139,87,0.4)" strokeWidth="1" />
          <text x="361" y="316" textAnchor="middle" fill="#5FD48B" fontSize="10" fontFamily="monospace">
            rPET Ready
          </text>
          <rect x="164" y="106" width="92" height="22" rx="2" fill="rgba(8,14,24,0.92)" stroke="rgba(212,175,55,0.4)" strokeWidth="1" />
          <text x="210" y="122" textAnchor="middle" fill="#D4AF37" fontSize="10" fontFamily="monospace">
            In-Line QC
          </text>
        </svg>
      </div>
    </section>
  );
}
